import { useAtom } from "@reatom/npm-react"
import React from "react"


function MessagesList({atom}){

    const [messages, ] = useAtom(atom)

    return (
        <div class="list-form__messages">
            {messages.map((message) => (
                <div className={`form-message -lvl-${message.level}`}>
                    {message.text}
                </div>
            ))}
        </div>
    )
}

export default MessagesList